export const example = "This is an exmaple.";

export const WORK_TYPES = {
    PICKING: {
        WorkTypeID: 1,
        Name: "Picking"
    },
    CROP_WORK: {
        WorkTypeID: 2,
        Name: "Crop Work"
    }
};

export const WORK_TYPES_ARRAY = [
    {
        WorkTypeID: -1,
        Name: "All"
    },
    {
        WorkTypeID: WORK_TYPES.PICKING.WorkTypeID,
        Name: WORK_TYPES.PICKING.Name
    },
    {
        WorkTypeID: WORK_TYPES.CROP_WORK.WorkTypeID,
        Name: WORK_TYPES.CROP_WORK.Name
    }
];

export const WORK_TYPES_ARRAY_NO_EXTRAS = WORK_TYPES_ARRAY.filter(function(item) {
    return item.WorkTypeID > 0;
});

export const HARVESTPLAN_UOM_ENUM = {
    KG : {
        ID: "KG",
        Name: "Kgs"
    },
    TRAYSPUNNETS : {
        ID: "TRAYSPUNNETS",
        Name: "Trays/Punnets"
    }
}

export const HARVESTPLAN_UOM = [
    {
        ID: HARVESTPLAN_UOM_ENUM.KG.ID,
        Name: HARVESTPLAN_UOM_ENUM.KG.Name
    },
    {
        ID: HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID,
        Name: HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.Name
    }
];

export const HARVESTPLAN_PAYSTYLE_ENUM = {
    HOURLY : {
        ID: "Hourly",
        Name: "Hourly"
    },
    PIECERATE : {
        ID: "Piece Rate",
        Name: "Piece Rate"
    }
}

export const HARVESTPLAN_PICKSTYLE_ENUM = {
    TRADITIONAL : {
        ID: "Traditional",
        Name: "Traditional"
    },
    PICKERSPLATFORM: {
        ID: "Pickers Platform",
        Name: "Pickers Platform"
    },
    PNP : {
        ID: "PnP",
        Name: "PnP"
    },
    BURRO : {
        ID: "Burro",
        Name: "Burro"
    }
}

export const HARVESTPLAN_PAYSTYLE = [
    {
        ID: HARVESTPLAN_PAYSTYLE_ENUM.HOURLY.ID,
        Name: HARVESTPLAN_PAYSTYLE_ENUM.HOURLY.Name
    },
    {
        ID: HARVESTPLAN_PAYSTYLE_ENUM.PIECERATE.ID,
        Name: HARVESTPLAN_PAYSTYLE_ENUM.PIECERATE.Name
    }
];

export const HARVESTPLAN_NOTICATIONS = [
    {
        ID: "First Fruit Pick",
        Color: "green"
    },
    {
        ID: "Multi Day Pick",
        Color: "orange"
    },
    {
        ID: "Do not Pick Seconds",
        Color: "brown"
    },
    {
        ID: "Last Pick",
        Color: "grey"
    },
    {
        ID: "Night Spray",
        Color: "blue"
    },
    {
        ID: "Premium Product",
        Color: "yellow"
    },
]

export const COMPANIES = {
    CHINA: {
        CompanyID: 6
    }
}